let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hgifA")).then(() => parcelRequire('04OD1'));